// Generated from /Volumes/Data/Code/Cobham/neko-paie/backend/formula/src/main/antlr/com/cobhamsolutions/nekopaie/formula/parser/Formula.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from 'antlr4';
import FormulaListener from './FormulaListener.js';
const serializedATN = [4,1,24,120,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,
4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,1,0,1,0,3,
0,27,8,0,1,1,1,1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,2,43,
8,2,1,2,1,2,1,2,1,2,1,2,1,2,5,2,51,8,2,10,2,12,2,54,9,2,1,3,1,3,1,4,1,4,
1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,3,5,71,8,5,1,5,1,5,1,5,1,5,1,
5,1,5,5,5,79,8,5,10,5,12,5,82,9,5,1,6,1,6,3,6,86,8,6,1,7,1,7,1,7,5,7,91,
8,7,10,7,12,7,94,9,7,1,8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,3,9,106,8,9,
1,10,1,10,3,10,110,8,10,1,11,1,11,1,11,5,11,115,8,11,10,11,12,11,118,9,11,
1,11,0,2,4,10,12,0,2,4,6,8,10,12,14,16,18,20,22,0,4,1,0,10,15,1,0,5,6,1,
0,3,4,2,0,20,22,24,24,123,0,26,1,0,0,0,2,28,1,0,0,0,4,42,1,0,0,0,6,55,1,
0,0,0,8,57,1,0,0,0,10,70,1,0,0,0,12,85,1,0,0,0,14,87,1,0,0,0,16,95,1,0,0,
0,18,105,1,0,0,0,20,109,1,0,0,0,22,111,1,0,0,0,24,27,3,2,1,0,25,27,3,8,4,
0,26,24,1,0,0,0,26,25,1,0,0,0,27,1,1,0,0,0,28,29,3,4,2,0,29,30,5,0,0,1,30,
3,1,0,0,0,31,32,6,2,-1,0,32,33,5,9,0,0,33,43,3,4,2,5,34,35,5,7,0,0,35,36,
3,4,2,0,36,37,5,8,0,0,37,43,1,0,0,0,38,39,3,10,5,0,39,40,3,6,3,0,40,41,3,
10,5,0,41,43,1,0,0,0,42,31,1,0,0,0,42,34,1,0,0,0,42,38,1,0,0,0,43,52,1,0,
0,0,44,45,10,4,0,0,45,46,5,16,0,0,46,51,3,4,2,5,47,48,10,3,0,0,48,49,5,17,
0,0,49,51,3,4,2,4,50,44,1,0,0,0,50,47,1,0,0,0,51,54,1,0,0,0,52,50,1,0,0,
0,52,53,1,0,0,0,53,5,1,0,0,0,54,52,1,0,0,0,55,56,7,0,0,0,56,7,1,0,0,0,57,
58,3,10,5,0,58,59,5,0,0,1,59,9,1,0,0,0,60,61,6,5,-1,0,61,62,5,4,0,0,62,71,
3,10,5,7,63,64,5,7,0,0,64,65,3,10,5,0,65,66,5,8,0,0,66,71,1,0,0,0,67,71,
3,18,9,0,68,71,3,16,8,0,69,71,3,14,7,0,70,60,1,0,0,0,70,63,1,0,0,0,70,67,
1,0,0,0,70,68,1,0,0,0,70,69,1,0,0,0,71,80,1,0,0,0,72,73,10,6,0,0,73,74,7,
1,0,0,74,79,3,10,5,7,75,76,10,5,0,0,76,77,7,2,0,0,77,79,3,10,5,6,78,72,1,
0,0,0,78,75,1,0,0,0,79,82,1,0,0,0,80,78,1,0,0,0,80,81,1,0,0,0,81,11,1,0,
0,0,82,80,1,0,0,0,83,86,5,23,0,0,84,86,3,16,8,0,85,83,1,0,0,0,85,84,1,0,
0,0,86,13,1,0,0,0,87,92,5,23,0,0,88,89,5,1,0,0,89,91,3,12,6,0,90,88,1,0,
0,0,91,94,1,0,0,0,92,90,1,0,0,0,92,93,1,0,0,0,93,15,1,0,0,0,94,92,1,0,0,
0,95,96,7,3,0,0,96,17,1,0,0,0,97,98,5,23,0,0,98,99,5,7,0,0,99,106,5,8,0,
0,100,101,5,23,0,0,101,102,5,7,0,0,102,103,3,22,11,0,103,104,5,8,0,0,104,
106,1,0,0,0,105,97,1,0,0,0,105,100,1,0,0,0,106,19,1,0,0,0,107,110,3,10,5,
0,108,110,3,4,2,0,109,107,1,0,0,0,109,108,1,0,0,0,110,21,1,0,0,0,111,116,
3,20,10,0,112,113,5,2,0,0,113,115,3,20,10,0,114,112,1,0,0,0,115,118,1,0,
0,0,116,114,1,0,0,0,116,117,1,0,0,0,117,23,1,0,0,0,118,116,1,0,0,0,12,26,
42,50,52,70,78,80,85,92,105,109,116];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

const sharedContextCache = new antlr4.atn.PredictionContextCache();

export default class FormulaParser extends antlr4.Parser {

    static grammarFileName = "Formula.g4";
    static literalNames = [ null, "':'", "','", "'+'", "'-'", "'*'", "'/'", 
                            "'('", "')'", "'!'", "'>'", "'<'", "'>='", "'<='", 
                            "'=='", "'!='", "'AND'", "'OR'" ];
    static symbolicNames = [ null, null, null, "PLUS", "MINUS", "TIMES", 
                             "DIVIDE", "LPAREN", "RPAREN", "NOT", "GT", 
                             "LT", "GTE", "LTE", "EQ", "NE", "AND", "OR", 
                             "LINE_COMMENT", "WS", "INTEGER", "INTEGER_LEADING_ZERO", 
                             "FLOAT", "IDENTIFIER", "STRING" ];
    static ruleNames = [ "calculable", "condition", "comparison", "comparator", 
                         "operation", "expression", "variablePart", "variable", 
                         "constant", "function", "arg", "argsList" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = FormulaParser.ruleNames;
        this.literalNames = FormulaParser.literalNames;
        this.symbolicNames = FormulaParser.symbolicNames;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 2:
    	    		return this.comparison_sempred(localctx, predIndex);
    	case 5:
    	    		return this.expression_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    comparison_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 4);
    		case 1:
    			return this.precpred(this._ctx, 3);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };

    expression_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 2:
    			return this.precpred(this._ctx, 6);
    		case 3:
    			return this.precpred(this._ctx, 5);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	calculable() {
	    let localctx = new CalculableContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, FormulaParser.RULE_calculable);
	    try {
	        this.state = 26;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,0,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 24;
	            this.condition();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 25;
	            this.operation();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	condition() {
	    let localctx = new ConditionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 2, FormulaParser.RULE_condition);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 28;
	        this.comparison(0);
	        this.state = 29;
	        this.match(FormulaParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	comparison(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ComparisonContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 4;
	    this.enterRecursionRule(localctx, 4, FormulaParser.RULE_comparison, _p);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 42;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
	        switch(la_) {
	        case 1:
	            this.state = 32;
	            this.match(FormulaParser.NOT);
	            this.state = 33;
	            this.comparison(5);
	            break;

	        case 2:
	            this.state = 34;
	            this.match(FormulaParser.LPAREN);
	            this.state = 35;
	            this.comparison(0);
	            this.state = 36;
	            this.match(FormulaParser.RPAREN);
	            break;

	        case 3:
	            this.state = 38;
	            this.expression(0);
	            this.state = 39;
	            this.comparator();
	            this.state = 40;
	            this.expression(0);
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 52;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,3,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 50;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,2,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new ComparisonContext(this, _parentctx, _parentState);
	                    this.pushNewRecursionContext(localctx, _startState, FormulaParser.RULE_comparison);
	                    this.state = 44;
	                    if (!( this.precpred(this._ctx, 4))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 4)");
	                    }
	                    this.state = 45;
	                    this.match(FormulaParser.AND);
	                    this.state = 46;
	                    this.comparison(5);
	                    break;

	                case 2:
	                    localctx = new ComparisonContext(this, _parentctx, _parentState);
	                    this.pushNewRecursionContext(localctx, _startState, FormulaParser.RULE_comparison);
	                    this.state = 47;
	                    if (!( this.precpred(this._ctx, 3))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 3)");
	                    }
	                    this.state = 48;
	                    this.match(FormulaParser.OR);
	                    this.state = 49;
	                    this.comparison(4);
	                    break;

	                } 
	            }
	            this.state = 54;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,3,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	comparator() {
	    let localctx = new ComparatorContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, FormulaParser.RULE_comparator);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 55;
	        _la = this._input.LA(1);
	        if(!((((_la) & ~0x1f) === 0 && ((1 << _la) & 64512) !== 0))) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	operation() {
	    let localctx = new OperationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, FormulaParser.RULE_operation);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 57;
	        this.expression(0);
	        this.state = 58;
	        this.match(FormulaParser.EOF);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	expression(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExpressionContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 10;
	    this.enterRecursionRule(localctx, 10, FormulaParser.RULE_expression, _p);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 70;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,4,this._ctx);
	        switch(la_) {
	        case 1:
	            this.state = 61;
	            this.match(FormulaParser.MINUS);
	            this.state = 62;
	            this.expression(7);
	            break;

	        case 2:
	            this.state = 63;
	            this.match(FormulaParser.LPAREN);
	            this.state = 64;
	            this.expression(0);
	            this.state = 65;
	            this.match(FormulaParser.RPAREN);
	            break;

	        case 3:
	            this.state = 67;
	            this.function_();
	            break;

	        case 4:
	            this.state = 68;
	            this.constant();
	            break;

	        case 5:
	            this.state = 69;
	            this.variable();
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 80;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,6,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 78;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,5,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new ExpressionContext(this, _parentctx, _parentState);
	                    this.pushNewRecursionContext(localctx, _startState, FormulaParser.RULE_expression);
	                    this.state = 72;
	                    if (!( this.precpred(this._ctx, 6))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
	                    }
	                    this.state = 73;
	                    _la = this._input.LA(1);
	                    if(!(_la===5 || _la===6)) {
	                    this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 74;
	                    this.expression(7);
	                    break;

	                case 2:
	                    localctx = new ExpressionContext(this, _parentctx, _parentState);
	                    this.pushNewRecursionContext(localctx, _startState, FormulaParser.RULE_expression);
	                    this.state = 75;
	                    if (!( this.precpred(this._ctx, 5))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                    }
	                    this.state = 76;
	                    _la = this._input.LA(1);
	                    if(!(_la===3 || _la===4)) {
	                    this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 77;
	                    this.expression(6);
	                    break;

	                } 
	            }
	            this.state = 82;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,6,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	variablePart() {
	    let localctx = new VariablePartContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, FormulaParser.RULE_variablePart);
	    try {
	        this.state = 85;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 23:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 83;
	            this.match(FormulaParser.IDENTIFIER);
	            break;
	        case 20:
	        case 21:
	        case 22:
	        case 24:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 84;
	            this.constant();
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	variable() {
	    let localctx = new VariableContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 14, FormulaParser.RULE_variable);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 87;
	        this.match(FormulaParser.IDENTIFIER);
	        this.state = 92;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,8,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 88;
	                this.match(FormulaParser.T__0);
	                this.state = 89;
	                this.variablePart(); 
	            }
	            this.state = 94;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,8,this._ctx);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	constant() {
	    let localctx = new ConstantContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 16, FormulaParser.RULE_constant);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 95;
	        _la = this._input.LA(1);
	        if(!((((_la) & ~0x1f) === 0 && ((1 << _la) & 24117248) !== 0))) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	function_() {
	    let localctx = new FunctionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 18, FormulaParser.RULE_function);
	    try {
	        this.state = 105;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,9,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 97;
	            this.match(FormulaParser.IDENTIFIER);
	            this.state = 98;
	            this.match(FormulaParser.LPAREN);
	            this.state = 99;
	            this.match(FormulaParser.RPAREN);
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 100;
	            this.match(FormulaParser.IDENTIFIER);
	            this.state = 101;
	            this.match(FormulaParser.LPAREN);
	            this.state = 102;
	            this.argsList();
	            this.state = 103;
	            this.match(FormulaParser.RPAREN);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	arg() {
	    let localctx = new ArgContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 20, FormulaParser.RULE_arg);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 109;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,10,this._ctx);
	        switch(la_) {
	        case 1:
	            this.state = 107;
	            this.expression(0);
	            break;

	        case 2:
	            this.state = 108;
	            this.comparison(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	argsList() {
	    let localctx = new ArgsListContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 22, FormulaParser.RULE_argsList);
	    var _la = 0;
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 111;
	        this.arg();
	        this.state = 116;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===2) {
	            this.state = 112;
	            this.match(FormulaParser.T__1);
	            this.state = 113;
	            this.arg();
	            this.state = 118;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

FormulaParser.EOF = antlr4.Token.EOF;
FormulaParser.T__0 = 1;
FormulaParser.T__1 = 2;
FormulaParser.PLUS = 3;
FormulaParser.MINUS = 4;
FormulaParser.TIMES = 5;
FormulaParser.DIVIDE = 6;
FormulaParser.LPAREN = 7;
FormulaParser.RPAREN = 8;
FormulaParser.NOT = 9;
FormulaParser.GT = 10;
FormulaParser.LT = 11;
FormulaParser.GTE = 12;
FormulaParser.LTE = 13;
FormulaParser.EQ = 14;
FormulaParser.NE = 15;
FormulaParser.AND = 16;
FormulaParser.OR = 17;
FormulaParser.LINE_COMMENT = 18;
FormulaParser.WS = 19;
FormulaParser.INTEGER = 20;
FormulaParser.INTEGER_LEADING_ZERO = 21;
FormulaParser.FLOAT = 22;
FormulaParser.IDENTIFIER = 23;
FormulaParser.STRING = 24;

FormulaParser.RULE_calculable = 0;
FormulaParser.RULE_condition = 1;
FormulaParser.RULE_comparison = 2;
FormulaParser.RULE_comparator = 3;
FormulaParser.RULE_operation = 4;
FormulaParser.RULE_expression = 5;
FormulaParser.RULE_variablePart = 6;
FormulaParser.RULE_variable = 7;
FormulaParser.RULE_constant = 8;
FormulaParser.RULE_function = 9;
FormulaParser.RULE_arg = 10;
FormulaParser.RULE_argsList = 11;

class CalculableContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_calculable;
    }

	condition() {
	    return this.getTypedRuleContext(ConditionContext,0);
	};

	operation() {
	    return this.getTypedRuleContext(OperationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterCalculable(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitCalculable(this);
		}
	}


}



class ConditionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_condition;
    }

	comparison() {
	    return this.getTypedRuleContext(ComparisonContext,0);
	};

	EOF() {
	    return this.getToken(FormulaParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterCondition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitCondition(this);
		}
	}


}



class ComparisonContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_comparison;
    }

	NOT() {
	    return this.getToken(FormulaParser.NOT, 0);
	};

	comparison = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ComparisonContext);
	    } else {
	        return this.getTypedRuleContext(ComparisonContext,i);
	    }
	};

	LPAREN() {
	    return this.getToken(FormulaParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(FormulaParser.RPAREN, 0);
	};

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	comparator() {
	    return this.getTypedRuleContext(ComparatorContext,0);
	};

	AND() {
	    return this.getToken(FormulaParser.AND, 0);
	};

	OR() {
	    return this.getToken(FormulaParser.OR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterComparison(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitComparison(this);
		}
	}


}



class ComparatorContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_comparator;
    }

	GT() {
	    return this.getToken(FormulaParser.GT, 0);
	};

	LT() {
	    return this.getToken(FormulaParser.LT, 0);
	};

	GTE() {
	    return this.getToken(FormulaParser.GTE, 0);
	};

	LTE() {
	    return this.getToken(FormulaParser.LTE, 0);
	};

	EQ() {
	    return this.getToken(FormulaParser.EQ, 0);
	};

	NE() {
	    return this.getToken(FormulaParser.NE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterComparator(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitComparator(this);
		}
	}


}



class OperationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_operation;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	EOF() {
	    return this.getToken(FormulaParser.EOF, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterOperation(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitOperation(this);
		}
	}


}



class ExpressionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_expression;
    }

	MINUS() {
	    return this.getToken(FormulaParser.MINUS, 0);
	};

	expression = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExpressionContext);
	    } else {
	        return this.getTypedRuleContext(ExpressionContext,i);
	    }
	};

	LPAREN() {
	    return this.getToken(FormulaParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(FormulaParser.RPAREN, 0);
	};

	function_() {
	    return this.getTypedRuleContext(FunctionContext,0);
	};

	constant() {
	    return this.getTypedRuleContext(ConstantContext,0);
	};

	variable() {
	    return this.getTypedRuleContext(VariableContext,0);
	};

	TIMES() {
	    return this.getToken(FormulaParser.TIMES, 0);
	};

	DIVIDE() {
	    return this.getToken(FormulaParser.DIVIDE, 0);
	};

	PLUS() {
	    return this.getToken(FormulaParser.PLUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterExpression(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitExpression(this);
		}
	}


}



class VariablePartContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_variablePart;
    }

	IDENTIFIER() {
	    return this.getToken(FormulaParser.IDENTIFIER, 0);
	};

	constant() {
	    return this.getTypedRuleContext(ConstantContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterVariablePart(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitVariablePart(this);
		}
	}


}



class VariableContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_variable;
    }

	IDENTIFIER() {
	    return this.getToken(FormulaParser.IDENTIFIER, 0);
	};

	variablePart = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(VariablePartContext);
	    } else {
	        return this.getTypedRuleContext(VariablePartContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterVariable(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitVariable(this);
		}
	}


}



class ConstantContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_constant;
    }

	INTEGER() {
	    return this.getToken(FormulaParser.INTEGER, 0);
	};

	INTEGER_LEADING_ZERO() {
	    return this.getToken(FormulaParser.INTEGER_LEADING_ZERO, 0);
	};

	FLOAT() {
	    return this.getToken(FormulaParser.FLOAT, 0);
	};

	STRING() {
	    return this.getToken(FormulaParser.STRING, 0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterConstant(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitConstant(this);
		}
	}


}



class FunctionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_function;
    }

	IDENTIFIER() {
	    return this.getToken(FormulaParser.IDENTIFIER, 0);
	};

	LPAREN() {
	    return this.getToken(FormulaParser.LPAREN, 0);
	};

	RPAREN() {
	    return this.getToken(FormulaParser.RPAREN, 0);
	};

	argsList() {
	    return this.getTypedRuleContext(ArgsListContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterFunction(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitFunction(this);
		}
	}


}



class ArgContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_arg;
    }

	expression() {
	    return this.getTypedRuleContext(ExpressionContext,0);
	};

	comparison() {
	    return this.getTypedRuleContext(ComparisonContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterArg(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitArg(this);
		}
	}


}



class ArgsListContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = FormulaParser.RULE_argsList;
    }

	arg = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ArgContext);
	    } else {
	        return this.getTypedRuleContext(ArgContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.enterArgsList(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof FormulaListener ) {
	        listener.exitArgsList(this);
		}
	}


}




FormulaParser.CalculableContext = CalculableContext; 
FormulaParser.ConditionContext = ConditionContext; 
FormulaParser.ComparisonContext = ComparisonContext; 
FormulaParser.ComparatorContext = ComparatorContext; 
FormulaParser.OperationContext = OperationContext; 
FormulaParser.ExpressionContext = ExpressionContext; 
FormulaParser.VariablePartContext = VariablePartContext; 
FormulaParser.VariableContext = VariableContext; 
FormulaParser.ConstantContext = ConstantContext; 
FormulaParser.FunctionContext = FunctionContext; 
FormulaParser.ArgContext = ArgContext; 
FormulaParser.ArgsListContext = ArgsListContext; 
